The details of the candidate profile to be uploaded.
